import api from '@/lib/api';
import type { AdminAnnouncementRow } from '@/types/admin';

export async function fetchAnnouncements(): Promise<AdminAnnouncementRow[]> {
  const { data } = await api.get('/admin/announcements');
  return data?.data ?? [];
}

export interface CreateAnnouncementPayload {
  title: string;
  message: string;
  severity: 'info' | 'warning' | 'critical';
  expiresAt?: string | null;
}

export async function createAnnouncement(
  payload: CreateAnnouncementPayload,
): Promise<AdminAnnouncementRow> {
  const { data } = await api.post('/admin/announcements', payload);
  return data?.data;
}

export async function deactivateAnnouncement(id: string): Promise<AdminAnnouncementRow> {
  const { data } = await api.patch(`/admin/announcements/${id}/deactivate`);
  return data?.data;
}
